<template>
  <div class="max-w-[530px] pt-20 text-white" v-if="disableWelcome">
    <p class="pb-8 font-bold text-2xl inika-bold">{{ greeting }}, {{ guestName }}.</p>
    <p class="pb-8 text-2xl inika-regular">We finally meet at The Telegraph Hotel, where every stay becomes a story. It’s a pleasure to have you with us. If there’s anything you need during your stay, we’re just a tap away.</p>
    <p class="font-bold text-2xl inika-bold">Warm wishes,</p>
    <p class="font-bold text-[24px] inika-bold">The Telegraph team</p>
  </div>
</template>

<script>
import {limitToLast, onChildAdded, query, ref} from "firebase/database";
import {db} from "@/firebase";

export default {
  name: 'WelcomeGuestMessage',
  data() {
    return {
      guestName     : "Dear Guest",
      roomStatus    : null,
      hotelToken    : null,
      roomId        : null,
      disableWelcome: false,
      greeting      : "",
    }
  },
  computed: {
    updateGreeting() {
      const hour = new Date().getHours();
      if (hour >= 6 && hour < 12) {
        this.greeting = "Good Morning";
      } else if (hour >= 12 && hour < 18) {
        this.greeting = "Good Afternoon";
      } else if (hour >= 18 && hour < 22) {
        this.greeting = "Good Evening";
      } else {
        this.greeting = "Good Night";
      }
    },
  },
  mounted() {
    this.updateGreeting;
    setInterval(this.updateGreeting, 60000);
    if (window.location.host === 'telegraph.dgstay.com' || window.location.host === "localhost:8080") {
      if (this.$root.getQueryVariable('room-uuid') !== false) {
        localStorage.setItem("room_uuid", this.$root.getQueryVariable('room-uuid'));
        localStorage.setItem("hotel_token", this.$root.getQueryVariable('hotel-token'));
      }
      this.roomUid    = localStorage.getItem('room_uuid');
      this.hotelToken = localStorage.getItem('hotel_token');
      this.subscribeFirebase();
      this.GetRoomGuestInfo()
      this.disableWelcome = true;
    }
  },
  methods: {
    async GetRoomGuestInfo() {
      let requestUrl = process.env.VUE_APP_API_URL + 'public/rooms?hotel_token=' + this.hotelToken + '&room_uuid=' + this.roomUid; //TODO: Hotel Token get env
      await this.$http.get(requestUrl).then(response => {
        const data = response.data;
        if (data.success) {
          if (data.data.fullName) {
            this.guestName  = data.data.fullName;
            this.roomStatus = data.data.status;
            this.$root.setPropertyToLocalStorage("1111", decodeURIComponent(this.guestName));
          }
        } else {
          console.log(response);
        }
      });
    },
    subscribeFirebase() {
      if (this.roomUid === null || this.roomStatus === "false") {
        console.log("subscribeFirebase room false");
        return;
      }
      const serverPrefix = 'eu';
      const channel      = `channels/${serverPrefix}/room/${this.roomUid}/messages`;
      // console.log(channel)
      let messageRef     = query(ref(db, channel), limitToLast(1));
      // console.log(messageRef)
      sessionStorage.setItem(`processedFirstRoomMessage_` + this.roomUid, 'false');

      onChildAdded(messageRef, (snapshot) => {
        // console.log('connecting......')
        if (sessionStorage.getItem(`processedFirstRoomMessage_` + this.roomUid) !== 'true') {
          sessionStorage.setItem(`processedFirstRoomMessage_` + this.roomUid, 'true');
          return;
        }
        const data = snapshot.val();
        if (data) {
          this.GetRoomGuestInfo()
        }
      });
    },
  }
}
</script>
